<app-header-brazil></app-header-brazil>
<section class="mt-5 mb-5">
    <div class="d-flex flex-row align-items-center">
        <h2 class="mr-3 mb-0">Cidades - {{state.nome}}</h2>
        <img src="https://devarthurribeiro.github.io/covid19-brazil-api/static/flags/{{state.sigla}}.png" alt="Bandeira do estado de {{state.nome}}" width="45" height="30">
    </div>

    <div class="state-cards">
        <div class="state-card box mt-4 mb-4 mr-5" *ngFor="let city of cities">
            <h3 class="text-center mb-3">{{numberWithCommas(city.nome)}}</h3>
            <p>Casos confirmados: <span>{{numberWithCommas(city.casos)}}</span></p>
            <p>Casos recuperados: <span>{{numberWithCommas(city.recuperados)}}</span></p>
            <p>Óbitos confirmados: <span>{{numberWithCommas(city.mortes)}}</span></p>
            <p class="mb-3">Dinheiro gasto: <span>R${{numberWithCommas(city.dinheiro)}}</span></p>
            <button routerLink="/brazil/state/city" [state]="{ cidade: city }" class="btn align-self-end">Ver mais detalhes<img class="ml-2" src="assets/icons/next.svg"></button>
        </div>
    </div>
</section>